<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormStock" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="TipoMovimiento">Tipo de Movimiento</label>
							<select v-model="TipoMovimiento" @change="CambiarTipoMovimiento" class="form-control-search form-select" id="TipoMovimiento">
                                <option value="1">Entrada</option>
                                <option value="2">Salida</option>
							</select>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <label class="form-label" for="Nombre">Cantidad</label>
                                <input type="text" v-model="objHerramienta.Stock" class="form-control" id="Stock" placeholder="Ingresar Cantidad" @input="$onlyNums($event,objHerramienta,'Stock');CalcularStock()"/>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>En Stock: </span><span>{{ StockActual }}</span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>Ahora: </span><span>{{ NuevoStock }}</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>Minimo Stock: </span><span>{{ objHerramienta.MinimoStock }}</span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <span>Máximo Stock: </span><span>{{ objHerramienta.MaximoStock }}</span>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name:'FormStock',
    props: ['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objHerramienta: {
				IdHerramienta: 0,
                Nombre:'',
				Stock: 0,
				TipoMovimiento:'',
                Cantidad:0,
                MinimoStock:0,
                MaximoStock:0
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			StockActual:0,
            NuevoStock:0,
            TipoMovimiento:"1"
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.DisableBtn = true;
            if ((Number(this.StockActual)+Number(this.objHerramienta.Stock))>this.objHerramienta.MaximoStock) {
                this.$toast.warning("El Nuevo Stock Es Mayor Al Máximo Registrado");
                this.poBtnSave.ShowSpinner=false;
                this.poBtnSave.DisableBtn=true;
                return false;
            }
            this.objHerramienta.Cantidad=this.objHerramienta.Stock;
            this.objHerramienta.Stock=this.NuevoStock;
            this.objHerramienta.TipoMovimiento=this.TipoMovimiento=="1" ? "Entrada"  : "Salida";
            await this.$http.put(
				'herramientasStock/'+this.objHerramienta.IdHerramienta,this.objHerramienta
			).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionMaterial');
        },
        EjecutaConError(err){
            this.objHerramienta.Stock=this.objHerramienta.Cantidad;
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get(
                "herramientas/"+this.objHerramienta.IdHerramienta
            ).then((res) => {
                this.objHerramienta = res.data.data;
                this.StockActual=res.data.data.Cantidad;
                this.objHerramienta.Stock=0;
                this.NuevoStock=this.StockActual;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.TipoMovimiento="1";
            this.objHerramienta = {
				IdHerramienta: 0,
				Nombre: '',
				Stock: 0,
				TipoMovimiento:'',
                Cantidad:0,
                MinimoStock:0,
                MaximoStock:0
            }
            this.errorvalidacion = [];
        },
        CambiarTipoMovimiento(){
            this.CalcularStock();
        },
        CalcularStock(){
            if (this.TipoMovimiento=="1") {
                this.NuevoStock=Number(this.StockActual)+Number(this.objHerramienta.Stock);
                this.poBtnSave.ShowSpinner=true;
                this.poBtnSave.DisableBtn=false;
            }
            else{
                if (Number(this.StockActual)-Number(this.objHerramienta.Stock)<0) {
                    this.$toast.warning("Stock Insuficiente");
                    this.poBtnSave.ShowSpinner=false;
                    this.poBtnSave.DisableBtn=true;
                }
                else{
                    this.NuevoStock=Number(this.StockActual)-Number(this.objHerramienta.Stock);
                    this.poBtnSave.ShowSpinner=true;
                    this.poBtnSave.DisableBtn=false;
                }
            }
        }
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            this.objHerramienta.IdHerramienta=Id;
            this.Recuperar();
        });
    }
}
</script>

<style>

</style>